import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';
import { useOrderStatusBreakdown } from '@hooks/dashboard/useKapi';

const COLORS: Record<string, string> = {
  COMPLETED: '#10B981',
  ORDER_CONFIRMED: '#3B82F6',
  PREPARING: '#F59E0B',
  CANCELED: '#EF4444',
  REFUNDED: '#8B5CF6',
  READY_FOR_PICKUP: '#06B6D4',
  PARTIALLY_READY_FOR_PICKUP: '#14B8A6',
};

const OrderStatusDonut: React.FC = () => {
  const { data, isLoading } = useOrderStatusBreakdown();

  if (isLoading) return <div className="chart-loading">Loading...</div>;

  const chartData = data && data.length > 0
    ? data.map(d => ({ name: d.status.replace(/_/g, ' '), value: d.count, pct: d.percentage }))
    : [{ name: 'No Data', value: 1, pct: 100 }];

  const renderLabel = ({ name, pct }: any) => `${pct}%`;

  return (
    <ResponsiveContainer width="100%" height={260}>
      <PieChart>
        <Pie
          data={chartData}
          cx="50%"
          cy="50%"
          innerRadius={55}
          outerRadius={90}
          paddingAngle={3}
          dataKey="value"
          label={renderLabel}
          labelLine={false}
        >
          {chartData.map((entry, index) => (
            <Cell key={index} fill={COLORS[entry.name.replace(/ /g, '_')] || '#D1D5DB'} />
          ))}
        </Pie>
        <Tooltip
          contentStyle={{ background: '#0B1829', border: 'none', borderRadius: 10, color: '#fff', fontSize: 12 }}
          formatter={(value: number, name: string) => [`${value} orders`, name]}
        />
        <Legend
          verticalAlign="bottom"
          iconType="circle"
          iconSize={8}
          wrapperStyle={{ fontSize: 10, color: '#6B7280' }}
        />
      </PieChart>
    </ResponsiveContainer>
  );
};

export default OrderStatusDonut;
